/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

class VirtualDomUtils {

  /**
  * @param {String} scriptSource
  * @returns {HTMLScriptElement}
  */
  static findScript(scriptSource) {
    const activeScripts = window.document.getElementsByTagName('script');
    for (const index in activeScripts) {
      if(
        activeScripts[index] &&
        activeScripts[index].src &&
        String(activeScripts[index].src) === String(scriptSource)
      ) {
        return activeScripts[index];
      }
    }
    return null;
  }


  /**
  * @param {String} scriptSource
  * @returns {Promise<HTMLScriptElement>}
  */
  static mountScript(scriptSource) {
    return new Promise((resolve, reject) => {
      const existingScript = VirtualDomUtils.findScript(scriptSource);
      if(existingScript) {
        resolve(existingScript);
      }
      else {
        try {
          const script = window.document.createElement("script");
          script.onload = () => resolve(script);
          script.src = scriptSource;
          window.document.body.appendChild(script);
        }
        catch(error) {
          reject(error);
        }
      }
    });
  }
}
export default VirtualDomUtils;
